
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/financial-calculator",
      function () {
        return require("private-next-pages/resources/financial-calculator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/financial-calculator"])
      });
    }
  